import { render } from "./BookBooking.vue?vue&type=template&id=62504c52"
import script from "./BookBooking.vue?vue&type=script&lang=js"
export * from "./BookBooking.vue?vue&type=script&lang=js"
script.render = render

export default script